// local
import Api from '.';

export function list() {
    return Api.get('/supplier');
}

export function create(data) {
    return Api.post('/supplier', data);
}

export function update(id, data) {
    return Api.put(`/supplier/${id}`, data);
}

export default { list, create, update };
